import { Component, inject, TemplateRef, ViewChild } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzNotificationData, NzNotificationService } from 'ng-zorro-antd/notification';

import { UiPlatformButtonComponent } from '../button/button.component';

@Component({
  selector: 'ui-platform-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.less',
  imports: [
    NzButtonModule,
    TranslocoPipe,
    UiPlatformButtonComponent
  ]
})
export class UiPlatformNotificationComponent {
  #notificationService = inject(NzNotificationService);

  @ViewChild(TemplateRef, { static: false }) template?: TemplateRef<any>;

  showNotification(
    title: string,
    content: string,
    placement: 'topRight' | 'bottomRight' | 'topLeft' | 'bottomLeft' = 'bottomLeft',
    duration = 20000,
    actionBtnTextI18n?: string,
    action?: () => void
  ): void {
    this.#notificationService.template(this.template!, {
      nzData: { title, content, actionBtnTextI18n, action } as NzNotificationData,
      nzDuration: duration,
      nzPlacement: placement
    });
  }
}
